<template>
  <div>
    <p>{{ label }} transaction created on {{ formatDate(details.created_at) }} (<a :href="link">Link</a>)</p>
    <ul class="list-unstyled object-details">
      <li>Amount: {{ details.amount }}</li>
      <li>Status: <span :class="statusClass">{{ status }}</span></li>
      <li  v-if="status == 'error'">Error Message: <span class="text-danger">{{ details.error_message }}</span></li>
    </ul>
  </div>
</template>

<script>
  import dayjs from 'dayjs';

  export default {
    name: "Payment",
    props: {
      details: {
        type: Object,
        default: function () {
          return {};
        }
      },
      label: {
        type: String,
        default: "Related to"
      }
    },
    computed: {
      link() {
        return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/transactions/${this.details.id}`
      },
      status() {
        if (this.details.has_error) {
          return 'error';
        } else if (this.details.approved) {
          return 'approved';
        } else if (this.details.processed) {
          return 'processed';
        } else {
          return 'pending';
        }
      },
      statusClass() {
        switch (this.status) {
          case 'error':
            return 'text-danger';
          case 'pending':
            return 'text-warning';
          case 'approved':
          return 'text-info';
          case 'processed':
            return 'text-success';
        }
      }
    },
    methods: {
      formatDate(date) {
        return dayjs(date).format('MM/DD/YY hh:mm A');
      },
    }
  }
</script>

<style scoped>

</style>